import { requestBuilder } from '../../http/RequestBuilder';

interface DeleteGoalAccountLinkURLParams {
    goalAccountLinkId: string;
}

const useDeleteGoalAccountLink = requestBuilder.mutation<
    null,
    null,
    DeleteGoalAccountLinkURLParams
>({
    endpoint: ({ goalAccountLinkId }) =>
        `/api/guidance/goals/account-link/${goalAccountLinkId}`,
    method: 'DELETE',
});

export default useDeleteGoalAccountLink;
